// Delete icons object when Button is replaced with new AppButton
const icons: { [key: string]: JSX.Element } = {
  plus: (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 12.5H15V6.5C15 5.94772 14.5523 5.5 14 5.5C13.4477 5.5 13 5.94772 13 6.5V12.5H7C6.44772 12.5 6 12.9477 6 13.5C6 14.0523 6.44772 14.5 7 14.5H13V20.5C13 21.0523 13.4477 21.5 14 21.5C14.5523 21.5 15 21.0523 15 20.5V14.5H21C21.5523 14.5 22 14.0523 22 13.5C22 12.9477 21.5523 12.5 21 12.5Z"
        fill="black"
      />
      <rect x="0.5" y="0.5" width="26" height="26" rx="13" stroke="black" />
    </svg>
  ),
  back: (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3723 14.25C10.1453 14.2508 9.93023 14.1487 9.78726 13.9725L6.16476 9.47248C5.93727 9.19573 5.93727 8.79673 6.16476 8.51998L9.91476 4.01998C10.1799 3.70104 10.6533 3.65738 10.9723 3.92248C11.2912 4.18758 11.3349 4.66104 11.0698 4.97998L7.71726 8.99998L10.9573 13.02C11.1445 13.2448 11.184 13.5579 11.0583 13.8222C10.9327 14.0864 10.6648 14.2534 10.3723 14.25Z"
        fill="black"
      />
    </svg>
  )
};

export const AddIcon = () => {
  return (
    <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 12.5H15V6.5C15 5.94772 14.5523 5.5 14 5.5C13.4477 5.5 13 5.94772 13 6.5V12.5H7C6.44772 12.5 6 12.9477 6 13.5C6 14.0523 6.44772 14.5 7 14.5H13V20.5C13 21.0523 13.4477 21.5 14 21.5C14.5523 21.5 15 21.0523 15 20.5V14.5H21C21.5523 14.5 22 14.0523 22 13.5C22 12.9477 21.5523 12.5 21 12.5Z"
        fill="black"
      />
      <rect x="0.5" y="0.5" width="26" height="26" rx="13" stroke="black" />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' fill='currentColor'>
      <path d='M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z'></path>
    </svg>
  );
};

export { icons };
